// extracted by mini-css-extract-plugin
export default {"relativeTimeHeader":"TopBar-module__relativeTimeHeader--ac186","relativeTimeHeaderInnerWrapper":"TopBar-module__relativeTimeHeaderInnerWrapper--a509f"};